import { useEffect, useState } from 'react';
import { ReactComponent as MoreIcon } from '../../../../assets/svg/kebab.svg';
import { ReactComponent as ChevronDownIcon } from '../../../../assets/svg/chevron-down.svg';
import { WEIGHT_UNIT } from '../../../../types/enum';
import { convertWeight } from '../../../../lib/utils';
import Note from './common/note';

const ProgramRoutineItem = ({ workoutTracker, openMenu, preference }) => {
  const [logs, setLogs] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (workoutTracker?.programRoutine?.cycleRoutine) {
      const sets = [];
      workoutTracker.programRoutine.sets.forEach((s) =>
        s.exercises.forEach((exe) => {
          sets.push({
            count: exe.modeValue,
            weight: exe.weight,
            name: exe.exercise.name,
            unit: exe.mode === 'REPS' ? 'reps' : 'seconds',
          });
        })
      );
      setLogs(sets);
    } else if (workoutTracker?.programRoutine) {
      const newGroups = [];
      workoutTracker.programRoutine.sets.reduce((acc, cur, i) => {
        if (Object.keys(acc).length === 0) {
          acc.setId = cur.setId;
          acc.exercises = cur.exercises.map((exe) => ({
            count: exe.modeValue,
            weight: exe.weight,
            name: exe.exercise.name,
            unit: exe.mode === 'REPS' ? 'reps' : 'seconds',
          }));
          acc.sets = 1;

          if (i === workoutTracker.programRoutine.sets.length - 1) {
            newGroups.push({ ...acc });
          }
          return acc;
        } else {
          if (acc.setId === cur.setId) {
            acc.sets++;

            if (i === workoutTracker.programRoutine.sets.length - 1) {
              newGroups.push({ ...acc });
            }
            return acc;
          } else {
            newGroups.push({ ...acc });

            const newAcc = {
              setId: cur.setId,
              exercises: cur.exercises.map((exe) => ({
                count: exe.modeValue,
                weight: exe.weight,
                name: exe.exercise.name,
                unit: exe.mode === 'REPS' ? 'reps' : 'seconds',
              })),
              sets: 1,
            };

            if (i === workoutTracker.programRoutine.sets.length - 1) {
              newGroups.push({ ...newAcc });
            }

            return newAcc;
          }
        }
      }, {});

      setLogs(newGroups);
    }
  }, [workoutTracker]);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='bg-secondary rounded-2xl p-4'>
      <div className='flex justify-between items-center gap-2 mb-4'>
        <div className='flex items-center gap-2'>
          <span className='text-white text-xs px-2 py-1 border border-tertiary rounded-full'>
            {workoutTracker.type}
          </span>
          <div className='text-white font-bold line-clamp-1'>
            {workoutTracker.workout}
          </div>
        </div>
        <div className='text-white'>
          <MoreIcon
            className='size-5'
            onClick={openMenu}
          />
        </div>
      </div>
      <div
        className={`transition-all duration-300 ease-in-out scrollbar-hidden ${
          isOpen
            ? 'space-y-4 max-h-screen opacity-100 overflow-y-auto mb-4'
            : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        {workoutTracker.workout !== 'REST' ? (
          workoutTracker.programRoutine.cycleRoutine ? (
            <div className='space-y-2 text-white text-sm'>
              <div className='flex items-center justify-between gap-2 mb-2'>
                <div>{logs.length} exercises</div>
                <div>{workoutTracker.cycle} cycle</div>
              </div>
              <div className='rounded-xl px-3 py-2 bg-tertiary divide-y-[1px] divide-white/10'>
                {logs.map((log, i) => (
                  <div
                    key={i}
                    className='w-full'
                  >
                    <div className='flex items-center justify-between gap-2'>
                      <div>{log.name}</div>
                      <div className='flex items-center gap-2 flex-shrink-0'>
                        {typeof log.weight === 'number' && log.weight > 0 && (
                          <div>
                            {preference?.weightUnit === WEIGHT_UNIT.LB
                              ? convertWeight(
                                  log.weight,
                                  WEIGHT_UNIT.KG,
                                  WEIGHT_UNIT.LB
                                ).toFixed(1)
                              : log.weight.toFixed(1)}{' '}
                            {preference?.weightUnit?.toLowerCase()}
                          </div>
                        )}
                        {typeof log.weight === 'number' && log.weight > 0 && (
                          <div>x</div>
                        )}
                        <div>
                          {log.count} {log.unit.toLowerCase()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className='space-y-2 text-white text-sm'>
              {logs.map((log, i) => (
                <div
                  key={i}
                  className='w-full'
                >
                  <div className='flex items-center justify-between gap-2 mb-2'>
                    <div>
                      {log.exercises.length}{' '}
                      {log.exercises.length > 1 ? 'exercises' : 'exercise'}
                    </div>
                    <div className='text-right'>{log.sets} sets</div>
                  </div>
                  <div className='rounded-xl px-3 py-2 bg-tertiary'>
                    <div className='divide-y-[1px] divide-white/10'>
                      {log.exercises.map((exe, i) => (
                        <div
                          key={i}
                          className='flex items-center justify-between gap-2'
                        >
                          <div>{exe.name}</div>
                          <div className='flex items-center gap-2'>
                            {typeof exe.weight === 'number' &&
                              exe.weight > 0 && (
                                <div>
                                  {preference?.weightUnit === WEIGHT_UNIT.LB
                                    ? convertWeight(
                                        exe.weight,
                                        WEIGHT_UNIT.KG,
                                        WEIGHT_UNIT.LB
                                      ).toFixed(1)
                                    : exe.weight.toFixed(1)}{' '}
                                  {preference?.weightUnit?.toLowerCase()}
                                </div>
                              )}
                            {typeof exe.weight === 'number' &&
                              exe.weight > 0 && <div>x</div>}
                            <div>
                              {exe.count} {exe.unit.toLowerCase()}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        ) : null}
        <Note note={workoutTracker.note} />
      </div>
      <div className='flex items-center justify-between text-xs'>
        <div className='flex items-center justify-center'>
          <div className='text-white border rounded-full px-2 py-1 bg-accent/20 border-accent/80'>
            {workoutTracker.feeling
              ? workoutTracker.feeling.replaceAll(',', ' ')
              : workoutTracker.level
              ? `Lv. ${workoutTracker.level ?? 1}`
              : 'Lv. 0'}
          </div>
        </div>
        {logs.length > 0 && (
          <div className='flex items-center justify-center'>
            <div className='text-white border rounded-full px-2 py-1 bg-accent/20 border-accent/80'>
              {workoutTracker.programRoutine.cycleRoutine
                ? `${logs.length} Exercises`
                : `${logs.reduce((acc, cur) => acc + cur.sets, 0)} Sets`}
            </div>
          </div>
        )}
        <div className='flex items-center justify-center'>
          <div className='text-white border rounded-full px-2 py-1 bg-accent/20 border-accent/80'>
            {workoutTracker.duration
              ? Math.ceil(workoutTracker.duration / 60)
              : 0}{' '}
            min
          </div>
        </div>
        {workoutTracker.workout !== 'REST' && (
          <div>
            <ChevronDownIcon
              className={`size-5 transition-transform duration-300 hover:cursor-pointer ${
                isOpen ? 'rotate-180' : ''
              }`}
              fill='white'
              onClick={handleOpen}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramRoutineItem;
